<template>
  <div class="bb-contact-form-mailing-select">
    <div class="bb-contact-form-mailing-select__title">
      {{RESPONSIBLE_CLIENT_TRACKING_LIST}}
      <HelpPopup
        :text="RESPONSIBLE_CLIENT_TRACKING_LIST_POPUP_TEXT"
        addClassPopup="type-middle"
      />
    </div>
    <v-select
      label="username"
      :options="clientList"
      :clearable="false"
      :appendToBody="true"
      :value="defaultValue"
      @input="onChangeInput"
      @open="open"
      @close="close"
    />
  </div>
</template>

<script>
import vSelect from 'vue-select'
import UsersListApi from '@/api/UsersList/api'
import HelpPopup from "../HelpPopup/HelpPopup.vue";
import {
  RESPONSIBLE_CLIENT_TRACKING_LIST,
  RESPONSIBLE_CLIENT_TRACKING_LIST_POPUP_TEXT,
} from '@/constants/companyFormText'

export default {
  name: 'ContactFormMailingSelect',
  components: {
    vSelect,
    HelpPopup,
  },
  props: {
    company: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    clientList: [],
    defaultValue: '',
    element: null,
    RESPONSIBLE_CLIENT_TRACKING_LIST,
    RESPONSIBLE_CLIENT_TRACKING_LIST_POPUP_TEXT,
  }),
  methods: {
    onChangeInput (value) {
      this.defaultValue = value
      const { _id } = value
      this.company.clientResponsible = _id
    },
    async getSelectUser () {
      try {
        const { data } = await UsersListApi.getSelectUser()
        this.clientList = data
        const { clientResponsible } = this.company
        const currentItem = this.clientList.find((el) => el._id === clientResponsible)
        this.defaultValue = currentItem
      } catch (err) {
        console.error(err)
      }
    },
    open () {
      const body = document.getElementsByTagName('body')
      const [element] = body
      this.element = element
      element.classList.add('dropdown-open-company')
    },
    close () {
      this.element.classList.remove('dropdown-open-company')
    }
  },
  beforeMount () {
    this.getSelectUser()
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables";

  .bb-contact-form-mailing-select {
    display: grid;
    align-items: center;
    grid-template-columns: 159px 323px;
    grid-gap: 0 36px;
    margin: 24px 0 0 0;

    &__title {
      font-size: 13px;
      font-weight: 600;
      line-height: 17px;
      color: $color-denim;
    }

  }
</style>

<style lang="scss">
@import "../../../../../sass/variables";

  .bb-contact-form-mailing-select {
    .vs__selected {
      text-transform: capitalize;
    }
  }

  .dropdown-open-company {

    .vs__dropdown-menu {
      text-transform: capitalize;
      font-family: $global-font;
      font-size: 12px;
      max-height: 144px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Settings/Companies/CompanyForm/ContactFormMailing/ContactFormMailingSelect.vue